module.exports = __webpack_public_path__ + "static/media/process-flow-2-icon.76385bf2.svg";